import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as ContractConfirm from './Saga/ContractConfirm';
import ContractConfirmGrid from "./ContractConfirmGrid";
import Search from "./Search";
import moment from 'moment'
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'redux'

const styles = (theme: any) => ({

    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },

})

// import { customerList,  customerNewDispSet } from '../../Store/Customers';

interface Props {
    // customerNewDispSet: any,
    // customerNewDisp:number,
    // customerno:number,
    // customerList:any,
    // toggle:any,
    // get_rent_contract_accounting:any,
    get_contract_confirm_rent_contracts_list: any,
    contract_confirm_backdrop: any,
    classes: any,
}



interface State {

    // state types
}


class ContractConfirmIndex extends Component<Props, State> {

    constructor(props: Readonly<Props>) {

        super(props);
        this.state = {
            modal: false,
            modal_contacts: false,
            modal_replace: false,
            // modalselect: false,
            change: false,
            search: '',


        };

        this.props.get_contract_confirm_rent_contracts_list()
    }




    componentWillMount() {
        // this.props.get_contract_confirm_rent_contracts_list()
        // this.props.customerNewDispSet(0)
        // this.submit = this.submit.bind(this);
    }
    //     aa(state:any){
    // console.log(state)
    //     }

    // submit(state: any) {
    //     console.log(state)

    //     // this.props.get_contract_confirm_rent_contracts_list(state)
    // }

    csv() {

        // this.props.get_rent_contract_accounting(this.props.kyousais);
    }
    render() {

        return (
            <div >
                <Backdrop
                    className={this.props.classes.backdrop}
                    open={this.props.contract_confirm_backdrop}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>


                <div style={{margin:3, paddingLeft:3, paddingRight:3, paddingTop:10}} className="item"
                // style={{ display: (this.props.customerNewDisp === 0) ? '' : 'none' }}
                >
                    <div className="" style={{float:"left"}}>
                        <Search />
                    </div>
                    <div className="" style={{float:"left", marginLeft:3}}>
                        <ContractConfirmGrid />
                    </div>
                </div>
                
            </div>
        );
    }
};


//export  default CustomerList;
const mapStateToProps = (state: any) => {
    return {

        rent_contract_list: state.ContractConfirm.rent_contract_list,
        contract_confirm_backdrop: state.ContractConfirm.contract_confirm_backdrop

    }
}
function mapDispatchToProps(dispatch: any) {
    return {

        get_contract_confirm_rent_contracts_list(state: any) {
            dispatch(ContractConfirm.get_contract_confirm_rent_contracts_list(state))
        },
    };
}

// export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(ContractConfirmIndex);
// export default connect(mapStateToProps, mapDispatchToProps)(ContractConfirmIndex);
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ContractConfirmIndex));




